module.exports = __webpack_public_path__ + "static/media/myAlpaca.6f43fe70.mp4";